import {SmallDesc} from "@ui/descriptions/SmallDesc";

import styles from "./styles.module.scss";

export const FormError = ({error, bottom, center = false}) => {
  return (
    <div
      className={styles.error}
      style={{
        bottom: `${bottom}rem`,
        textAlign: center ? "center" : "left",
        left: center ? "50%" : "0",
        transform: center ? "translateX(-50%)" : "none",
      }}
    >
      <SmallDesc>
        <span>{error}</span>
      </SmallDesc>
    </div>
  );
};
